var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "emd-container _highlight_header no-border" },
    [
      _c("div", { staticClass: "emd-table-responsive" }, [
        _c("table", { staticClass: "emd-table" }, [
          _c("thead", [
            _c("tr", [
              _c("th", [
                _vm._v(
                  _vm._s(_vm.$t("charge.detail.recipients.columns.installment"))
                ),
              ]),
              _c("th", [
                _vm._v(
                  _vm._s(_vm.$t("charge.detail.recipients.columns.status"))
                ),
              ]),
              _c("th", [
                _vm._v(_vm._s(_vm.$t("charge.detail.recipients.columns.date"))),
              ]),
              _c("th", [
                _vm._v(
                  _vm._s(
                    _vm.$t("charge.detail.recipients.columns.gross-amount")
                  )
                ),
              ]),
              _c("th", [
                _vm._v(
                  _vm._s(_vm.$t("charge.detail.recipients.columns.input"))
                ),
              ]),
              _c("th", [
                _vm._v(
                  _vm._s(_vm.$t("charge.detail.recipients.columns.output"))
                ),
              ]),
              _c("th", [
                _vm._v(_vm._s(_vm.$t("charge.detail.recipients.columns.fees"))),
              ]),
              _c("th", [
                _vm._v(
                  _vm._s(_vm.$t("charge.detail.recipients.columns.net-amount"))
                ),
              ]),
            ]),
          ]),
          _c(
            "tbody",
            _vm._l(_vm.rows, function (item, index) {
              return _c("tr", { key: index }, [
                _c(
                  "td",
                  {
                    attrs: {
                      "data-label": _vm.$t(
                        "charge.detail.recipients.columns.installment"
                      ),
                    },
                  },
                  [_vm._v(" " + _vm._s(item.installment) + " ")]
                ),
                _c(
                  "td",
                  {
                    attrs: {
                      "data-label": _vm.$t(
                        "charge.detail.recipients.columns.status"
                      ),
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "emd-badge",
                        class: _vm.statusClass(item.status),
                      },
                      [_vm._v(_vm._s(item.status))]
                    ),
                  ]
                ),
                _c(
                  "td",
                  {
                    attrs: {
                      "data-label": _vm.$t(
                        "charge.detail.recipients.columns.date"
                      ),
                    },
                  },
                  [
                    _c("div", { staticClass: "eu-flex eu-column" }, [
                      item.original_payment_date
                        ? _c("span", { staticClass: "scratched" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("dateFormat")(
                                    item.original_payment_date,
                                    "date"
                                  )
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                      item.payment_date
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("dateFormat")(
                                    item.payment_date,
                                    "date"
                                  )
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                ),
                _c(
                  "td",
                  {
                    attrs: {
                      "data-label": _vm.$t(
                        "charge.detail.recipients.columns.gross-amount"
                      ),
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.formatValue(
                            item.gross_amount.value,
                            item.gross_amount.currency_symbol
                          )
                        ) +
                        " "
                    ),
                  ]
                ),
                _c(
                  "td",
                  {
                    attrs: {
                      "data-label": _vm.$t(
                        "charge.detail.recipients.columns.input"
                      ),
                    },
                  },
                  [
                    _c("span", { staticClass: "emd-text _color_success" }, [
                      _vm._v(
                        _vm._s(
                          _vm.formatValue(
                            item.input.value,
                            item.input.currency_symbol
                          )
                        )
                      ),
                    ]),
                  ]
                ),
                _c(
                  "td",
                  {
                    attrs: {
                      "data-label": _vm.$t(
                        "charge.detail.recipients.columns.output"
                      ),
                    },
                  },
                  [
                    _c("span", { staticClass: "emd-text _color_danger" }, [
                      _vm._v(
                        _vm._s(
                          _vm.formatValue(
                            item.output.value,
                            item.output.currency_symbol
                          )
                        )
                      ),
                    ]),
                  ]
                ),
                _c(
                  "td",
                  {
                    attrs: {
                      "data-label": _vm.$t(
                        "charge.detail.recipients.columns.fees"
                      ),
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        class: `emd-text ${
                          item.fees.value > 0
                            ? "_color_success"
                            : "_color_danger"
                        }`,
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.formatValue(
                              item.fees.value,
                              item.fees.currency_symbol
                            )
                          )
                        ),
                      ]
                    ),
                  ]
                ),
                _c(
                  "td",
                  {
                    attrs: {
                      "data-label": _vm.$t(
                        "charge.detail.recipients.columns.net-amount"
                      ),
                    },
                  },
                  [
                    _c("span", { staticClass: "emd-text _color_info" }, [
                      _vm._v(
                        _vm._s(
                          _vm.formatValue(
                            item.net_amount.value,
                            item.net_amount.currency_symbol
                          )
                        )
                      ),
                    ]),
                  ]
                ),
              ])
            }),
            0
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }